import axios from 'axios';
// import { debounce } from "lodash";
import Vue from 'vue';

let interval;

function clearCookieInterval() {
  if (interval) {
    clearInterval(interval);
  }
}

export const useSessionManager = () => {
  const init = async (authUser) => {
    let token;

    // firebase handler
    if (authUser && authUser.providerId && authUser.providerId === 'firebase') {
      token = authUser.accessToken;
    }

    console.log('[useSessionManager.js] init session with id token', token);

    if (token) {
      Vue.$cookies.remove('__4life-signout', '/', process.env.VUE_APP_SESSION_DOMAIN);

      try {
        await axios.post(
          process.env.VUE_APP_SESSION_MANAGER_ENDPOINT,
          {},
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getSessionToken = async () => {
    const response = await axios.get(`${process.env.VUE_APP_SESSION_MANAGER_ENDPOINT}/me`, {
      withCredentials: true
    });

    const { token } = response.data;

    return token;
  };

  const clearSessionToken = async (token) => {
    await axios.post(
      process.env.VUE_APP_SESSION_MANAGER_ENDPOINT,
      { invalidate: true },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    clearCookieInterval();

    Vue.$cookies.set(
      '__4life-signout',
      'learn4life',
      3600,
      '/',
      process.env.VUE_APP_SESSION_DOMAIN,
      true
    );
  };

  const registerSignOutListener = (cb) => {
    var checkCookie = function () {
      const signOutCookie = Vue.$cookies.get('__4life-signout');

      if (signOutCookie && signOutCookie !== 'learn4life') {
        console.log(
          '[useSessionManager.js] detect sign out cookie signal, clear interval and call given callback'
        );

        clearCookieInterval();

        // Vue.$cookies.remove(
        //   "__4life-signout",
        //   "/",
        //   process.env.VUE_APP_SESSION_DOMAIN
        // );

        // console.log(
        //   "[useSessionManager.js] cookie has been removed, check cookie value",
        //   Vue.$cookies.get("__4life-signout")
        // );

        cb();
      }
    };

    if (!interval) {
      checkCookie();

      interval = setInterval(checkCookie, 1000);
    }
  };

  return {
    init,
    getSessionToken,
    clearSessionToken,
    registerSignOutListener
  };
};
